<template>
    <div class="card flex flex-column" :id="id">
        <div v-if="title" class="flex justify-content-between align-items-center">
            <div class="flex align-items-center">
                <i
                    v-if="icon"
                    class="border-circle bg-primary w-2rem h-2rem text-xl flex align-items-center justify-content-center mr-2 flex-shrink-0"
                    :class="icon"
                ></i>
                <h2>{{ title }}</h2>
            </div>
            <template v-if="showAllUrl">
                <Button :label="$t('lang.report.dashboard.show_all')" :link="true" @click="onClickLink" />
            </template>
        </div>
        <div :class="{scoped: scoped, open: (scoped && isScopedOpen)}" class="z-auto">
            <slot></slot>
            <div v-if="$slots.showAllButton" class="templates_form__show_all_button_container flex justify-content-center mt-4">
                <slot name="showAllButton"></slot>
            </div>
        </div>
        <div v-if="scoped && !isScopedOpen" class="templates_form__open_container flex justify-content-center z-2 pt-6 -mt-6">
            <Button :label="$t('lang.report.dashboard.open_scoped')" @click="onOpenScoped" size="small" severity="secondary" />
        </div>
    </div>
</template>

<script>
import Button from "primevue/button";

export default {
    name: "DashboardDomainTemplateForm",
    props: {
        icon: {
            type: String,
            required: false,
        },
        title: {
            type: String,
            required: false,
        },
        showAllUrl: {
            type: String,
            required: false,
            default: null,
        },
        id: {
            type: String,
            required: false,
            default: null
        },
        scoped: {
            type: Boolean,
            required: false,
            default: false
        },
    },
    data() {
        return {
            isScopedOpen: false,
        }
    },
    methods: {
        onClickLink() {
            window.open(this.showAllUrl);
        },
        onOpenScoped() {
            this.isScopedOpen = true;
        }
    },
    components: {
        Button,
    }
}
</script>

<style scoped>
.scoped {
    max-height: 25rem;
    overflow: hidden;
}
.scoped.open {
    max-height: unset;
}
.templates_form__open_container {
    background: linear-gradient( rgba(255, 255, 255, 0), rgba(255, 255, 255, 1) );
}
.templates_form__show_all_button_container:deep(.p-button) {
    background-color: var(--keysso-table-even-row-background);
    border: 1px solid var(--keysso-table-even-row-background);
    color: var(--keysso-secondary-link-color);
    transition: .3s;
}
.templates_form__show_all_button_container:deep(.p-button:hover) {
    border: 1px solid var(--keysso-secondary-link-color);
}
.templates_form__show_all_button_container:deep(.p-button:active) {
    color: var(--primary-color-text);
    background-color: var(--keysso-secondary-link-color);
}
</style>
